export default __webpack_public_path__ + "static/media/UserAdmin.2c99e002.png";